import { Toolbar as TB } from '@/components/Remirror/Toolbar';
import {
  BoldButton,
  ItalicButton,
  LinkButton,
  UnderlineButton,
} from '@/components/Remirror/Toolbar.Commands';


type Props = {
  className?: string;
};

export const Toolbar = ({ className }: Props) => {

  return (
    <TB className={className}>
      <BoldButton />
      <ItalicButton />
      <UnderlineButton />
      <LinkButton />
    </TB>
  );
};